export interface Flashcard {
  id: string;
  topic: string;
  question: string;
  answer: string;
  category: string;
  difficulty: 'easy' | 'medium' | 'hard';
  tags: string[];
  createdAt: Date;
  updatedAt: Date;
}

export interface UserProgress {
  userId: string;
  flashcardId: string;
  easeFactor: number;
  interval: number;
  repetitions: number;
  nextReviewDate: Date;
  lastReviewed: Date;
  quality: number; // 0-5 scale for SM-2 algorithm
  timesCorrect: number;
  timesIncorrect: number;
}

export interface StudySession {
  id: string;
  userId: string;
  startTime: Date;
  endTime?: Date;
  flashcardsStudied: number;
  correctAnswers: number;
  totalTime: number; // in minutes
  technique: StudyTechnique;
}

export enum StudyTechnique {
  ACTIVE_RECALL = 'active_recall',
  FEYNMAN = 'feynman',
  STRUCTURAL = 'structural',
  INTERLEAVING = 'interleaving',
  DUAL_CODING = 'dual_coding'
}

export type SourceFilter = 'all' | 'frcs' | 'journal';

export interface User {
  id: string;
  email: string;
  createdAt: Date;
  settings: UserSettings;
}

export interface UserSettings {
  dailyGoal: number;
  preferredTechnique: StudyTechnique;
  notifications: boolean;
  theme: 'light' | 'dark';
}

export interface StudyStats {
  totalCards: number;
  cardsStudied: number;
  averageAccuracy: number;
  streakDays: number;
  totalStudyTime: number;
  techniqueUsage: Record<StudyTechnique, number>;
  progressByTopic: Record<string, number>;
}

export interface JournalEntry {
  topic: string;
  content: string;
  references: string[];
  keyPoints: string[];
  category: string;
}
